module.exports = __webpack_public_path__ + "static/security3@2x-1ee50bb823660f917d78ff3d9fbbb996.png";